// Builds the effective field list for a YSA group: every company sensor (always
// auto-included, read-only) followed by the group's admin-defined manual fields.
// Used identically to render the Spektrofotometre/Deney panels and the Hesapla inputs,
// so the three stay positionally consistent (this order = the model's input order).
export function buildEffectiveFields(sensors, group) {
    const sensorFields = (sensors || []).map(s => ({
        _id: s._id,
        name: s.sensorName,
        type: 'sensor',
        sensorUUID: s.sensorUUID,
        unit: s.unit
    }));
    const manualFields = (group?.fields || []).map(f => ({
        _id: f._id,
        name: f.name,
        type: 'manual'
    }));
    return [...sensorFields, ...manualFields];
}
